import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import styles from './Badge.module.scss';
import { BadgeSize, BadgeColor } from '../../enums';
const Badge = ({ size = BadgeSize.Big, color = BadgeColor.Brand, isRounded, className, children, ...restProps }) => {
    return (_jsx("span", { className: classnames('d-inline-flex justify-content-center align-items-center fw-semibold', styles.badge, styles[color], styles[size], { [styles.isRounded]: isRounded }, className), ...restProps, children: children }));
};
export { Badge };
